import { cleanCombat } from "./combat";
import { cleanObjectives } from "./objectives";

export function aggregatePositionalStats(combatData, objectivesData) {
  let objectivesAggregate = aggregateObjectivesData(objectivesData);
  let combatAggregate = aggregateCombatStats(combatData, getAverageGameLengthPerRole(objectivesAggregate));

  return combineAggregates(objectivesAggregate, combatAggregate);
}

function getAverageGameLengthPerRole(objectivesAggregate) {
  let averages = {};
  for (let [role] of Object.entries(objectivesAggregate)) {
    averages[role] = objectivesAggregate[role].averageMinutesPerGame;
  }

  return averages;
}

function aggregateObjectivesData(objectivesData) {
  let aggregate = {};
  let cleanedData = cleanObjectives(objectivesData);

  let objectives = (cleanedData && cleanedData.objectives) || {};
  if (!objectives) return aggregate;

  let roles = Object.keys(objectives);
  roles.forEach((role) => {
    aggregate[role] = getObjectiveAggregateForChampions(objectives[role]);
  });

  return aggregate;
}

function getObjectiveAggregateForChampions(chamionsList) {
  let total = {
    cs: 0,
    gold: 0,
    wardsKilled: 0,
    minutes: 0,
    matches: 0,
  };

  chamionsList.forEach((champion) => {
    total = {
      cs: total.cs + (champion.jungle_cs + champion.enemy_jungle_cs + champion.cs) * champion.matches,
      gold: total.gold + champion.gold * champion.matches,
      wardsKilled: total.wardsKilled + champion.wards_killed * champion.matches,
      minutes: total.minutes + champion.match_duration * champion.matches,
      matches: total.matches + champion.matches,
    };
  });

  let averages = {
    averageCsPerMinute: total.cs / total.minutes,
    averageGoldPerMinute: total.gold / total.minutes,
    averageWardsKilledPerGame: total.wardsKilled / total.matches,
    averageMinutesPerGame: total.minutes / total.matches,
  };

  return averages;
}

function aggregateCombatStats(combatData, averageMinutesPerGameByRole) {
  let aggregate = {};
  let cleanedData = cleanCombat(combatData);

  let combat = (cleanedData && cleanedData.combat) || {};
  let roles = combat && Object.keys(combat);
  roles.forEach((role) => {
    aggregate[role] = getCombatAggregateForChampions(combat[role], averageMinutesPerGameByRole[role] || 0);
  });

  return aggregate;
}

function getCombatAggregateForChampions(championsList, averageMinutesPerGame) {
  let total = {
    damageMitigated: 0,
    damageHealed: 0,
    damageDealt: 0,
    kills: 0,
    deaths: 0,
    assists: 0,
    matches: 0,
  };

  championsList.forEach((champion) => {
    total = {
      damageMitigated: total.damageMitigated + champion.damage_mitigated * champion.matches,
      damageHealed: total.damageHealed + champion.heals * champion.matches,
      damageDealt: total.damageDealt + champion.damage * champion.matches,
      kills: total.kills + champion.kills * champion.matches,
      deaths: total.deaths + champion.deaths * champion.matches,
      assists: total.assists + champion.assists * champion.matches,
      matches: total.matches + champion.matches,
    };
  });

  let averages = {
    averageDmgHealedPerGame: total.damageHealed / total.matches,
    averageDmgMitigatedPerGame: total.damageMitigated / total.matches,
    averageDmgDealtPerMinute: total.damageDealt / (total.matches * averageMinutesPerGame),
    averageKda: (total.kills + total.assists) / total.deaths,
  };

  return averages;
}

function combineAggregates(objectivesAggregate, combatAggregate) {
  if (!objectivesAggregate || !combatAggregate) return;

  let combinedAggregate = {};

  for (let [role] of Object.entries(objectivesAggregate)) {
    combinedAggregate[role] = objectivesAggregate[role];
  }

  for (let [role] of Object.entries(combatAggregate)) {
    if (combinedAggregate[role]) {
      combinedAggregate[role] = { ...combinedAggregate[role], ...combatAggregate[role] };
    } else {
      combinedAggregate[role] = combatAggregate[role];
    }
  }

  return combinedAggregate;
}
